import styled from 'styled-components';

export const Divider = styled.div`
  border-right: 1px solid #d8d8d8;
  height: 32px;
  margin: 0 12px 0 6px;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/Divider.tsx